module.exports = __webpack_public_path__ + "img/korslider3.05629e2a.webp";